// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__kzwZi","label":"SetPasswdForm_label__1Bsbd"};